import { createApp } from 'vue';

const enquiryForm = async () => {
    const list = document.querySelector('.enquiry-form');
    if (!list) {
        return;
    }

    const app = createApp({
        delimiters: ['${', '}'],
        data() {
            return {
            };
        },
        mounted() {

        },
        methods: {
        },
        created() {
        }
    });

    app.mount(list);
};

export default enquiryForm;
